import { render, staticRenderFns } from "./chiffrage-prise-en-charge-assurance-proprietaire.vue?vue&type=template&id=b4a354d6&scoped=true"
import script from "./chiffrage-prise-en-charge-assurance-proprietaire.vue?vue&type=script&lang=ts"
export * from "./chiffrage-prise-en-charge-assurance-proprietaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a354d6",
  null
  
)

export default component.exports